var Shopify = Shopify || {};

Shopify.formatMoney = function (cents, format = Shopify.money_format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


class WIQCartProgressBar extends HTMLElement {
  constructor() {
    super();
    this.freeShippingThreshold = parseInt(this.dataset.freeShippingThreshold) || 0;
    this.freeGiftThreshold = parseInt(this.dataset.freeGiftThreshold) || 0;
    this.freeGiftVariantId = parseInt(this.dataset.freeGiftProductId);
    this.maxThreshold = Math.max(this.freeShippingThreshold, this.freeGiftThreshold);
    this.freeGiftMessage = this.dataset.freeGiftMessage || 'Free gift unlocked!';
    this.isProcessingGift = false; // Flag to prevent concurrent operations
   

    // Elements
    this.cartJsonEl = this.querySelector('[data-cart-json]');
    this.progressFillEl = this.querySelector('[data-progress-bar]');
    this.shippingIconEl = this.querySelector('[data-shipping-icon]');
    this.giftIconEl = this.querySelector('[data-gift-icon]');
    this.freeGiftMessageEl = this.querySelector('[data-free-gift-message]');
  }
  connectedCallback() { 
    this.cartJson = JSON.parse(this.cartJsonEl.textContent);
    this.initProgress();
    this.updateProgress();
    
    // Check and update gift status when component is initialized
    // This will also run when cart HTML is replaced by updateView
    this.addOrRemoveGiftFromCart();
  }


  getCartTotalExcludingGift() {
    if (this.isGiftInCart()) {
      return this.cartJson.total_price - this.cartJson.items.find(item => item.variant_id === this.freeGiftVariantId).final_line_price;
    }
    return this.cartJson.total_price;
  }

  isGiftInCart() {
    return this.cartJson.items.some(item => item.variant_id === this.freeGiftVariantId);
  }




  initProgress() { 
    this.precentages = [];
    if (this.freeShippingThreshold > 0) { 
      this.freeShippingProgress = Math.round(this.freeShippingThreshold / this.maxThreshold * 100, 2);
      this.freeShippingProgress = this.freeShippingProgress > 100 ? 100 : this.freeShippingProgress;
      this.precentages.push({
        thershold: this.freeShippingThreshold,
        percentage: this.freeShippingProgress,
        text: 'more to get free shipping',
      });
      this.shippingIconEl.style.left = this.freeShippingProgress + '%';
    }
    if (this.freeGiftThreshold > 0) { 
      this.freeGiftProgress = Math.round(this.freeGiftThreshold / this.maxThreshold * 100);
      this.freeGiftProgress = this.freeGiftProgress > 100 ? 100 : this.freeGiftProgress;
      this.precentages.push({
        thershold: this.freeGiftThreshold,
        percentage: this.freeGiftProgress,
        text: 'more to get a free gift',
      });
      this.giftIconEl.style.left = this.freeGiftProgress + '%';
    }

    // Sort by percentage in ascending order (lowest first, then higher)
    this.precentages.sort((a, b) => a.percentage - b.percentage);


  }
  updateProgress() {
    this.cartTotal = this.getCartTotalExcludingGift();
    this.progressPercentage =  this.cartTotal / this.maxThreshold * 100;
    this.progressPercentage = this.progressPercentage > 100 ? 100 : this.progressPercentage;
    this.progressFillEl.style.width = this.progressPercentage + '%';
    if (this.progressPercentage >= 100) {
      this.freeGiftMessageEl.textContent = this.freeGiftMessage;
    } else {
      // Find the first threshold (highest first) that hasn't been reached yet
      for (const percentage of this.precentages) {
        if ( percentage.percentage > this.progressPercentage) {
          const remaining = percentage.thershold - this.cartTotal;
          const text = `Add  <strong>${Shopify.formatMoney(remaining)}</strong> ${percentage.text}`;
          this.freeGiftMessageEl.innerHTML = text;
          return;
        }
      }
     
    }
  }

  getCartConfig() {
    // Get cart config from DOM (same way theme.js does it)
    const cartConfigEl = document.getElementById('cart-config');
    if (!cartConfigEl) {
      return null;
    }
    try {
      return JSON.parse(cartConfigEl.innerHTML || '{}');
    } catch (error) {
      console.error('Error parsing cart config:', error);
      return null;
    }
  }

  async addOrRemoveGiftFromCart() {
    // Only proceed if free gift threshold is set and gift variant ID is available
    if (!this.freeGiftThreshold || !this.freeGiftVariantId) {
      return;
    }

    // Prevent concurrent operations
    if (this.isProcessingGift) {
      return;
    }

    try {
      this.isProcessingGift = true;

      // Get current cart total excluding gift
      const cartTotal = this.getCartTotalExcludingGift();
      const giftInCart = this.isGiftInCart();
      const meetsThreshold = cartTotal >= this.freeGiftThreshold;

      // If threshold is met and gift is not in cart, add it
      if (meetsThreshold && !giftInCart) {
        await Shopify.theme.cart.addItem(this.freeGiftVariantId, { quantity: 1 });
        // Get updated cart and refresh view using theme's updateView method
        const updatedCart = await Shopify.theme.cart.getCart();
        const config = this.getCartConfig();
        if (config && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.updateView) {
          Shopify.theme.ajaxCart.updateView(config, updatedCart);
        }
      }
      // If threshold is not met and gift is in cart, remove it
      else if (!meetsThreshold && giftInCart) {
        const giftItem = this.cartJson.items.find(item => item.variant_id === this.freeGiftVariantId);
        if (giftItem) {
          await Shopify.theme.cart.removeItem(giftItem.key);
          // Get updated cart and refresh view using theme's updateView method
          const updatedCart = await Shopify.theme.cart.getCart();
          const config = this.getCartConfig();
          if (config && Shopify.theme.ajaxCart && Shopify.theme.ajaxCart.updateView) {
            Shopify.theme.ajaxCart.updateView(config, updatedCart);
          }
        }
      }
    } catch (error) {
      console.error('Error adding/removing gift from cart:', error);
    } finally {
      this.isProcessingGift = false;
    }
  }

  
}

customElements.define('wiq-cart-progress-bar', WIQCartProgressBar);